import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Trans } from "react-i18next";
import i18n from "i18n";
import { Button } from "components/bootstrap";
import { DataTable } from "components/common";
import notificationTypeTitle from "components/event-notifications/notificationTypeTitle";
const t = (key) => i18n.t(key, { ns: "event_definitions" });
const getNotificationPlugin = (type) => {
  if (type === void 0) {
    return void 0;
  }
  return PluginStore.exports("eventNotificationTypes").find((n) => n.type === type);
};
class NotificationList extends React.Component {
  constructor() {
    super(...arguments);
    this.handleRemoveClick = (notificationId) => () => {
      const { onRemoveNotificationClick } = this.props;
      onRemoveNotificationClick(notificationId);
    };
    this.notificationFormatter = (notification) => {
      if (notification.missing) {
        return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, /* @__PURE__ */ React.createElement(
          Trans,
          {
            i18n,
            ns: "event_definitions",
            i18nKey: "notification_list.not_found",
            values: { title: notification.title },
            components: { em: /* @__PURE__ */ React.createElement("em", null) }
          }
        )), /* @__PURE__ */ React.createElement("td", { className: "actions" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: this.handleRemoveClick(notification.title) }, i18n.t("common:actions.delete"))));
      }
      const plugin = getNotificationPlugin(notification.config.type);
      return /* @__PURE__ */ React.createElement("tr", { key: notification.id }, /* @__PURE__ */ React.createElement("td", null, notification.title), /* @__PURE__ */ React.createElement("td", null, notificationTypeTitle(plugin) || notification.config.type), /* @__PURE__ */ React.createElement("td", { className: "actions" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: this.handleRemoveClick(notification.id) }, i18n.t("common:actions.delete"))));
    };
  }
  render() {
    const { eventDefinition, notifications, onAddNotificationClick } = this.props;
    const definitionNotifications = eventDefinition.notifications.map(
      (edn) => notifications.find((n) => n.id === edn.notification_id) || {
        title: edn.notification_id,
        missing: true
      }
    );
    const addNotificationButton = /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onAddNotificationClick }, t("add_notification_form.add"));
    if (definitionNotifications.length === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("notification_list.no_notifications")), addNotificationButton);
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      DataTable,
      {
        id: "event-definition-notifications",
        headers: [t("notification_list.notification"), t("notification_list.type"), t("summary.actions")],
        sortByKey: "title",
        rows: definitionNotifications,
        dataRowFormatter: this.notificationFormatter,
        filterKeys: []
      }
    ), addNotificationButton);
  }
}
export default NotificationList;
